import {Typography, Alert, TextField, InputAdornment, IconButton, Stack} from '@mui/material';
import {useState} from 'react';
import {redeemCode} from "./RedeemCode";
import SendIcon from "@mui/icons-material/Send";
import React from 'react';

function VoucherForm() {
    const [code, setCode] = useState('');
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(false);

    const onTextChanged = (evt) => {
        setCode(evt.target.value);
        setMessage('');
    }

    const onKeyDown = (evt) => {
        if(evt.key === 'Enter') {
            sendVoucher();
        }
    }

    const sendVoucher = () => {
        redeemCode(code)
            .then((result) => {
                setSuccess(true);
                setMessage(result[0]);
                setTimeout(function () {
                    window.location.href = result[1];
                }, 2000);
            })
            .catch((result) => {
                setSuccess(false);
                setMessage(result[0]);
            })
    }

    return (
        <Stack spacing={'1rem'}>
            <Typography variant={'body2'} sx={{marginBottom: '1rem'}}>
                Bitte geben Sie den Buchungscode ein.
            </Typography>
            <TextField
                autoFocus={true}
                label={'Buchungscode'}
                value={code}
                onChange={onTextChanged}
                onKeyDown={onKeyDown}
                fullWidth
                InputProps={{
                    endAdornment: <InputAdornment position={'end'}>
                        <IconButton onClick={sendVoucher} edge={'end'} color={'primary'} disabled={code.length < 2}><SendIcon /></IconButton>
                    </InputAdornment>
                }}
            />
            {message.length > 0 && (<Alert severity={success ? 'success' : 'error'}>{message}</Alert>)}
        </Stack>
    );
}
export default VoucherForm;
